import React from "react";
import { useFormContext } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import CustomDatepicker from "@/components/customeDatepicker";

type Props = {
  name: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  isFutureDateDisabled?: boolean;
};

const RhfCustomDatepicker = ({
  name,
  label,
  required = false,
  disabled = false,
  placeholder = "Select date",
  isFutureDateDisabled = false,
}: Props) => {
  const { control } = useFormContext();
  const maxDate = isFutureDateDisabled ? new Date() : undefined;

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && (
            <FormLabel>
              {label}
              {required ? "*" : ""}
            </FormLabel>
          )}
          <FormControl>
            <CustomDatepicker
              value={
                field.value
                  ? String(field.value).split("T")[0]?.slice(0, 10)
                  : ""
              }
              onChange={field.onChange}
              placeholder={placeholder}
              disabled={!!disabled}
              maxDate={maxDate}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default RhfCustomDatepicker;
